import type {
  CivilityType,
  UserStatus,
} from '@djust-b2b/djust-front-sdk/lib/interfaces/models/customer-user';
import type { UserGetters } from './types';

export function useUserGetters(): UserGetters {
  const getUserId = (user: User): string => {
    return user?.id;
  };

  const getUserCreatedAt = (user: User): string => {
    return user?.createdAt;
  };

  const getUserUpdatedAt = (user: User): string => {
    return user?.updatedAt;
  };

  const getUserCivility = (user: User): CivilityType => {
    return user?.civility as CivilityType;
  };

  const getUserFirstName = (user: User): string => {
    return user?.firstName;
  };

  const getUserLastName = (user: User): string => {
    return user?.lastName;
  };

  const getUserFullName = (user: User): string => {
    return `${user?.firstName} ${user?.lastName}`;
  };

  const getUserEmail = (user: User): string => {
    return user?.email;
  };

  const getUserExternalId = (user: User): string => {
    return user?.externalId;
  };

  const getUserGroups = (user: User): string[] => {
    return user?.groups;
  };

  const getUserStatus = (user: User): UserStatus => {
    return user?.status as UserStatus;
  };

  const getUserPhone = (user: User): string => {
    return user?.phone;
  };

  const getUserCustomFieldValues = (user: User): any[] => {
    return user?.customFieldValues;
  };
  const getUserCurrency = (): string => {
    const currencyBase = useRuntimeConfig().public.currency as Currency;
    const userStore = useUserStore();
    return userStore.currency ?? currencyBase;
  };

  return {
    getUserId,
    getUserCreatedAt,
    getUserUpdatedAt,
    getUserCivility,
    getUserFirstName,
    getUserLastName,
    getUserFullName,
    getUserEmail,
    getUserExternalId,
    getUserGroups,
    getUserStatus,
    getUserPhone,
    getUserCustomFieldValues,
    getUserCurrency,
  };
}
